import React from 'react'
import styles from './styles.module.scss'

interface BackButtonProps {
    onClick: () => void
    text?: string
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, text = 'Back' }) => {
    return (
        <button type="button" className={styles.backButton} onClick={onClick}>
            {text}
        </button>
    )
}

export default BackButton
